import router from "./index";
import {MessageBox} from 'element-ui'

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  if(pattern.test(error))
  {
    MessageBox.confirm('系统已升级，请点击下方的"刷新"按钮完成功能更新。', '温馨提示', {
      showCancelButton:false,
      showClose:false,
      distinguishCancelAndClose:true,
      confirmButtonText: '刷新',
      type: 'warning',
    }).then(() => {
      window.location.reload()//页面刷新
    }).catch(() => {
     console.log('什么鬼')
    });
  }else{
    console.log(error)
  }
});



// WEBPACK FOOTER //
// ./src/router/routerCheck.js